import { useCallback, useEffect, useId, useRef, useState } from "react";
import {
  Container,
  MobileSupportContainer,
  SearchBarSection,
  SearchBarSectionSubcontainer,
  SummarySection,
} from "./styles";
import SearchBar from "../../components/ui-v2/Inputs/Search";
import TabsGroup from "../../components/ui/groups/TabsGroup";
import { useTypedSelector } from "../../hooks/useTypedSelector";
import DropdownFilter from "../../components/ui-v2/DropdownFilter";
import {
  /* Table , */ TCellNotTagMiscellaneous,
  TCellStyleVariants,
  TTableBody,
} from "../../components/ui-v2/TableGrid";
import { breakStringPreserveSpaces, cnpjMask } from "../../utils/formatters";

import {
  TInvoice,
  TInvoiceEntryStatus,
  TPaymentSlip,
  setAttachedInvoices,
  setIsLoadingPaymentSlips,
  setIsRestoringQuerystring,
  setToastState,
} from "../../redux/reducers/globalState";
import { useTypedDispatch } from "../../hooks/useTypedDispatch";
import {
  attachInvoiceToPaymentSlip,
  detachInvoiceFromPaymentSlip,
  fetchPaymentSlips,
  importPaymentSlipPDF,
  linkPaymentSlipToPayable,
  renameInvoiceLabel,
  updatePaymentSlipLaunchStatus,
} from "../../redux/actions";
import {
  CALENDAR_SLIP_CONTENT_OPTIONS,
  TCalendarMenuOptions,
  TCalendarSlipMenuOptions,
} from "../../components/ui-v2/DropdownFilter/Menu";
import { format } from "date-fns/format";
import { parse } from "date-fns/parse";
import {
  backendErrorMessageHandler,
  getQuerystringParams,
  handleParseToDateCalendarOptions,
  handleRevertTranslateCalendarOptions,
  handleSetDataToLocalStorage,
  handleSetEndDate,
  handleTranslateCalendarOptions,
  TQuerystringParams,
} from "../../utils/miscellaneous";
import { localStorageConstants } from "../../utils/constants";
import Modal from "../../components/ui-v2/Modal";
import TableGrid from "../../components/ui-v2/TableGrid";
import apiService from "../../services/api";
import { TPayableAccount } from "../../components/ui-v2/Modal/Forms/LinkPayable";
import { useNavigationManager } from "../../hooks/useNavigationManager";
import Button from "../../components/ui-v2/Button";
import { UilAngleDown, UilCopyAlt, UilLink } from "@iconscout/react-unicons";
import AttachmentMenu from "../../components/ui-v2/Menus/AttachmentMenu";
import { ROUTES } from "../../router";
import Tooltip from "../../components/ui-v2/Tooltip";
import axios, { CancelTokenSource } from "axios";
import { parseISO } from "date-fns/parseISO";
import { useProportionalGridTemplateColumns } from "../../hooks/useProportionalGridTemplateColumns";

function PaymentSlip() {
  const dispatch = useTypedDispatch();

  const reduxQuerystring = useTypedSelector((state) => state.querystring);

  const { paymentSlipState, attachedInvoices } = useTypedSelector(
    (state) => state.globalState.data
  );

  const isLoading = useTypedSelector(
    (state) => state.globalState.isLoadingPaymentSlips
  );

  const isRestoringQuerystring = useTypedSelector(
    (state) => state.globalState.isRestoringQuerystring
  );

  const selectedOrganization = useTypedSelector(
    (state) => state.organizations.selectedOrganization
  );

  const sidebarState = useTypedSelector((state) => state.sidebar);

  const cancelTokenSource = useRef<CancelTokenSource>(
    axios.CancelToken.source()
  );

  const fetchPaymentSlipsCancelTokenRef = useRef<CancelTokenSource>(
    axios.CancelToken.source()
  );

  const debounceRef = useRef<NodeJS.Timeout | null>(null);

  const startDateRef = useRef<string | undefined>();
  /* format(sub(new Date(), { days: 30 }), "yyyy-MM-dd") */
  const endDateRef = useRef<string | undefined>();
  /* format(new Date(), "yyyy-MM-dd") */

  const [launchStatus, setLaunchStatus] = useState<
    TInvoiceEntryStatus | undefined
  >(
    reduxQuerystring.launch_status === 40
      ? undefined
      : (reduxQuerystring.launch_status as TInvoiceEntryStatus)
  );

  const entryStatusRef = useRef<TInvoiceEntryStatus | undefined>(
    reduxQuerystring.launch_status === 40
      ? undefined
      : (reduxQuerystring.launch_status as TInvoiceEntryStatus)
  );
  // Entry status filter state and logic (adapted from Home/index.tsx)
  // Ref to hold the working selection for the entry status filter
  const entryStatusFilterRef = useRef<string[]>([]);
  // Ref to hold setSelected for use in onCancel
  const entryStatusSetSelectedRef = useRef<React.Dispatch<
    React.SetStateAction<string[]>
  > | null>(null);

  const payablesRef = useRef<boolean | undefined>();
  const goodsEntryRef = useRef<boolean | undefined>();
  const pageRef = useRef(1);
  const itemsPerPageRef = useRef(100);
  const searchRef = useRef<string | undefined>();
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const clearSelectedInvoicesRef = useRef<(() => void) | null>(null);

  const selectPayableRef = useRef<TPayableAccount>();

  const payableModalPaymentSlipRef = useRef<TPaymentSlip | undefined>();
  const allPaymentSlipsRef = useRef<TPaymentSlip[]>([]);

  // Store refs for each row's button
  const buttonRefs = useRef<{ [key: string]: HTMLButtonElement | null }>({});
  // Store which menu is open
  const [openMenuRow, setOpenMenuRow] = useState<string | null>(null);

  const searchBarContainerId = useId();

  const [paymentSlipToAttachLinks, setPaymentSlipToAttachLinks] =
    useState<TPaymentSlip | null>(null);

  const [paymentSlipToDelete, setPaymentSlipToDelete] = useState<
    TPaymentSlip | undefined
  >();
  const [invoiceToBreakLink, setInvoiceToBreakLink] = useState<
    { target: TInvoice; origin: TPaymentSlip } | undefined
  >();

  const [invoiceToRename, setInvoiceToRename] = useState<
    TInvoice | undefined
  >();

  const [shouldShowAttachmentMenu, setShouldShowAttachmentMenu] = useState("");

  const [shouldOpenPayable, setShouldOpenPayable] = useState(false);

  const [shouldOpenPayableModal, setShouldOpenPayableModal] = useState(false);
  const [shouldOpenLinkPayableModal, setShouldOpenLinkPayableModal] =
    useState(false);
  const [isLinkPayableLoading, setIsLinkPayableLoading] = useState(false);
  const [shouldUpdateComponent, _setShouldUpdateComponent] = useState(false);

  const [
    shouldOpenInstallmentAccountModal,
    setShouldOpenInstallmentAccountModal,
  ] = useState(false);

  const [shouldOpenLinkInvoiceModal, setShouldOpenLinkInvoiceModal] =
    useState(false);

  const [shouldRejectFilledEntryStatus /* setShouldRejectFilledEntryStatus */] =
    useState(false);

  const { setQuerystring } = useNavigationManager();

  const entryStatusOptions = [
    "Sem lançamentos",
    "Contas a pagar lançada",
    // "Entrada de mercadorias lançada",
  ];

  const SHOULD_DISABLE_FINTERA_ACTIONS =
    selectedOrganization && !selectedOrganization.permissions?.fintera;

  // 24px 100px 330px 453px 462px 326px 301px 304px 100px
  const originalWidths = [24, 100, 330, 453, 462, 326, 301, 304, 100, 0];
  const sidebarOffset = sidebarState.isFixed /* && sidebarState.isOpen */
    ? 240
    : 48;

  const gridTemplateColumns =
    useProportionalGridTemplateColumns(originalWidths);

  const rowFormatter = (paymentSlip: TPaymentSlip, _index: number) => {
    return [
      {
        style: "default",
        value: paymentSlip?.process_date
          ? format(parseISO(paymentSlip.process_date), "dd/MM/yyyy")
          : "-",
      },
      {
        style: "default",
        value:
          paymentSlip.source.length > 0
            ? paymentSlip.source
            : paymentSlip.user?.email
            ? paymentSlip.user.email
            : "-",
      },
      {
        style: "miscellaneous",
        tooltip: (() => {
          const name =
            paymentSlip.provider_name.length > 0
              ? paymentSlip.provider_name
              : "-";

          return (
            name && {
              text: (() => {
                const values = breakStringPreserveSpaces(name, 24);

                return values.map((value, index) => ({
                  style: "default",
                  text: value,
                  shouldBreakLine: index !== values.length - 1,
                }));
              })(),

              hasScrollableRef: true,
            }
          );
        })(),
        values: (() => {
          const name =
            paymentSlip.provider_name.length > 0
              ? paymentSlip.provider_name
              : "-";

          return [
            {
              style: "bold",
              text: name
                ? name.length > 20
                  ? name.slice(0, 20) + "..."
                  : name
                : "-",
              shouldBreakLine: true,
            },
            {
              style: "default",
              text: paymentSlip?.provider_document
                ? cnpjMask(paymentSlip?.provider_document)
                : "-",
              shouldBreakLine: false,
            },
          ];
        })(),
      },
      {
        style: "default",
        value:
          paymentSlip?.amount !== null
            ? "R$ " + paymentSlip.amount?.replace(".", ",")
            : "-",
      },
      {
        style: "default",
        value: paymentSlip?.due_date
          ? format(parseISO(paymentSlip?.due_date), "dd/MM/yyyy")
          : "-",
      },
      [
        {
          style: "button",
          icon:
            paymentSlip.accounts_payable_url === null
              ? "payableYellow"
              : paymentSlip.accounts_payable_url.length > 0
              ? "payableGreen"
              : "payableYellow",
          isDisabled:
            (paymentSlip.accounts_payable_url !== null &&
              paymentSlip.accounts_payable_url.length === 0) ||
            SHOULD_DISABLE_FINTERA_ACTIONS,
          tooltip:
            !SHOULD_DISABLE_FINTERA_ACTIONS &&
            paymentSlip.accounts_payable_url === null
              ? {
                  text: [
                    {
                      style: "default",
                      text: "Clique para criar uma ",
                      shouldBreakLine: false,
                    },
                    {
                      style: "bold",
                      text: "conta a pagar ",
                      shouldBreakLine: false,
                    },
                    {
                      style: "default",
                      text: "na Fintera",
                      shouldBreakLine: false,
                    },
                  ],

                  hasScrollableRef: true,
                }
              : SHOULD_DISABLE_FINTERA_ACTIONS ||
                (paymentSlip.accounts_payable_url as string).length === 0
              ? {
                  text: [
                    {
                      style: "default",
                      text: "Criar conta a pagar indisponível",
                      shouldBreakLine: false,
                    },
                  ],

                  hasScrollableRef: true,
                }
              : {
                  text: [
                    {
                      style: "default",
                      text: "Conta a pagar criada.",
                      shouldBreakLine: true,
                    },
                    {
                      style: "default",
                      text: "Clique para visualizar na Fintera",
                      shouldBreakLine: false,
                    },
                  ],

                  hasScrollableRef: true,
                },

          onClick() {
            if (paymentSlip.accounts_payable_url === null) {
              payableModalPaymentSlipRef.current = paymentSlip;
              setShouldOpenPayable(true);
            } else {
              window.open(
                paymentSlip.accounts_payable_url
                  ? paymentSlip.accounts_payable_url
                  : "",
                "_blank"
              );
            }
          },
        },
      ],
      {
        style: "button",
        icon: "ellipsisV",
        hasScrollableRef: true,
        isDisabled:
          paymentSlip.file_boleto === null &&
          [30].includes(paymentSlip.launch_status) &&
          paymentSlip.accounts_payable_url !== null,
        content: [
          paymentSlip.file_boleto !== null && "downloadFile",
          ![30].includes(paymentSlip.launch_status) && "deletePaymentSlip",
          paymentSlip.accounts_payable_url === null && "openPayableModal",
        ],
        onClick(select: string) {
          handleSetDataToLocalStorage(
            localStorageConstants.SELECT_INVOICE,
            paymentSlip
          );
          handleSetDataToLocalStorage(
            localStorageConstants.CURRENT_ENTRY_STATUS,
            entryStatusRef.current === undefined ? 40 : entryStatusRef.current
          );
          if (select.includes("delete")) {
            setPaymentSlipToDelete(paymentSlip);
          }
          if (select.includes("download")) {
            window.open(paymentSlip.file_boleto, "_blank");
          }

          if (select === "openPayableModal") {
            payableModalPaymentSlipRef.current = paymentSlip;
            setShouldOpenPayable(true);
          }
        },
      },
    ] as TTableBody<TCellStyleVariants>[];
  };

  const handleSecondRowLeftSideCustomNodeRender = (
    paymentSlip: TPaymentSlip,
    _index: number
  ) => {
    return (
      <span>
        <Tooltip
          text={[{ text: "Copiar", style: "default", shouldBreakLine: false }]}
        >
          <button
            role="button"
            onClick={() => {
              navigator.clipboard.writeText(paymentSlip.bar_code).then(() => {
                dispatch(
                  setToastState({
                    variant: "success",
                    message: {
                      title: "Sucesso",
                      description: "Linha digitável copiada",
                    },
                    shouldShow: true,
                  })
                );
              });
            }}
          >
            <UilCopyAlt />
          </button>
        </Tooltip>
      </span>
    );
  };

  const handleSecondRowRightSideCustomNodeRender = (
    paymentSlip: TPaymentSlip,
    rowIndex: number
  ) => {
    return paymentSlip.invoices_exists ? (
      <span style={{ position: "relative", display: "inline-block" }}>
        <button
          ref={(el) => (buttonRefs.current[rowIndex] = el)}
          role="button"
          data-testid="link-container"
          onClick={() => {
            if (attachedInvoices.length > 0) {
              dispatch(setAttachedInvoices([]));
              setShouldShowAttachmentMenu("");
              setOpenMenuRow(null);
            } else {
              cancelTokenSource.current = axios.CancelToken.source();
              apiService
                .getPaymentSlipAttachedInvoices(
                  paymentSlip.uuid,
                  (cancelTokenSource.current as CancelTokenSource).token
                )
                .then((response: any) => {
                  dispatch(setAttachedInvoices(response.data));
                  setShouldShowAttachmentMenu(`${rowIndex}`);
                  setOpenMenuRow(`${rowIndex}`);
                });
            }
          }}
        >
          Ver notas fiscais <UilAngleDown />
        </button>
        {shouldShowAttachmentMenu === `${rowIndex}` &&
          attachedInvoices.length > 0 &&
          openMenuRow === `${rowIndex}` && (
            <div
              style={{
                position: "absolute",
                top: buttonRefs.current[rowIndex]?.offsetHeight || 40,
                right: 0,
                zIndex: 1000,
                minWidth: 240,
                // Add your menu styling here (background, shadow, etc)
              }}
            >
              <AttachmentMenu
                shouldShowMenu
                onClickAway={() => {
                  dispatch(setAttachedInvoices([]));
                  setShouldShowAttachmentMenu("");
                  setOpenMenuRow(null);
                }}
                items={attachedInvoices.map((invoice: TInvoice) => {
                  return {
                    onRename() {
                      setInvoiceToRename(invoice);
                    },
                    onDelete:
                      invoice.fintera_id && invoice.fintera_id.length > 0
                        ? undefined
                        : () => {
                            setInvoiceToBreakLink({
                              target: invoice,
                              origin: paymentSlip,
                            });
                          },
                    name: invoice.label,
                    searchParam: invoice.access_key,
                    url:
                      ROUTES.INVOICES + window.location.search + "&period=all",
                  };
                })}
                onAction={{
                  callback: () => {
                    setPaymentSlipToAttachLinks(paymentSlip);
                    setShouldOpenLinkInvoiceModal(true);
                    dispatch(setAttachedInvoices([]));
                    setShouldShowAttachmentMenu("");
                  },
                  text: "Vincular nota fiscal",
                }}
              />
            </div>
          )}
      </span>
    ) : (
      <span>
        <p>Nenhuma nota vinculada</p>
        <button
          role="button"
          data-testid="link-container"
          onClick={() => {
            setPaymentSlipToAttachLinks(paymentSlip);
            setShouldOpenLinkInvoiceModal(true);
          }}
        >
          <UilLink />
          &nbsp;Vincular
        </button>
      </span>
    );
  };

  const secondRowDataFormatter = (invoice: TPaymentSlip) => ({
    style: "miscellaneous",
    values: [
      {
        style: "default",
        text: "Linha digitável: ",
        shouldBreakLine: false,
      },
      {
        style: "faded",
        text:
          invoice.bar_code.length > 0 ? invoice.bar_code : "(Não identificada)",
        shouldBreakLine: false,
      },
    ],
  });

  const handleCalendarOnClear = () => {
    const querystring = { ...reduxQuerystring };

    startDateRef.current = undefined;
    endDateRef.current = undefined;
    delete querystring.start_date;
    delete querystring.end_date;
    querystring.period = "all";

    setQuerystring(querystring);

    debouncedUpdateAllPaymentSlipsRef();
  };

  const handleCalendarOnSelect = (selected: string[]) => {
    const select = selected as TCalendarSlipMenuOptions[];

    const querystring = { ...reduxQuerystring };

    if (CALENDAR_SLIP_CONTENT_OPTIONS.includes(select[0])) {
      const tempStartDate = handleParseToDateCalendarOptions(select[0]);

      if (tempStartDate === undefined) {
        startDateRef.current = undefined;
        endDateRef.current = undefined;

        delete querystring.start_date;
        delete querystring.end_date;
        querystring.period = "all";

        if (querystring.page) {
          querystring.page = 1;
        }

        if (querystring.modal) {
          delete querystring.modal;
        }

        setQuerystring(querystring);

        debouncedUpdateAllPaymentSlipsRef();
      } else {
        const formatTempStartDate = format(tempStartDate, "yyyy-MM-dd");
        if (formatTempStartDate !== startDateRef.current) {
          const formatEndDate = handleSetEndDate(select[0]);

          startDateRef.current = formatTempStartDate;
          if (formatEndDate !== endDateRef.current)
            endDateRef.current = formatEndDate;

          querystring.period = handleTranslateCalendarOptions(
            select[0] as TCalendarMenuOptions
          ) as string;
          delete querystring.start_date;
          delete querystring.end_date;

          if (querystring.page) {
            querystring.page = 1;
          }

          if (querystring.modal) {
            delete querystring.modal;
          }

          setQuerystring(querystring);

          debouncedUpdateAllPaymentSlipsRef(undefined, formatEndDate);
        }
      }
    } else {
      const dates = select[0].split(" - ");
      const parsedStart =
        dates[0] && typeof dates[0] === "string"
          ? parse(dates[0], "dd/MM/yyyy", new Date())
          : undefined;
      const tempStartDate =
        parsedStart && !isNaN(parsedStart.getTime())
          ? format(parsedStart, "yyyy-MM-dd")
          : "";

      const parsedEnd =
        dates[1] && typeof dates[1] === "string"
          ? parse(dates[1], "dd/MM/yyyy", new Date())
          : undefined;
      const tempEndDate =
        parsedEnd && !isNaN(parsedEnd.getTime())
          ? format(parsedEnd, "yyyy-MM-dd")
          : "";

      if (tempStartDate !== startDateRef.current)
        startDateRef.current = tempStartDate;
      if (tempEndDate !== endDateRef.current) endDateRef.current = tempEndDate;

      querystring.end_date = tempEndDate;
      querystring.start_date = tempStartDate;
      querystring.period = undefined;

      if (querystring.page) {
        querystring.page = 1;
      }

      if (querystring.modal) {
        delete querystring.modal;
      }

      setQuerystring(querystring);

      setTimeout(() => {
        debouncedUpdateAllPaymentSlipsRef();
      }, 100);
    }
  };

  // Handles user selection, updates refs and state (uses entryStatusFilterRef as source of truth)
  const handleEntryStatusCustomFilter = (
    index: string,
    _selected: string[],
    setSelected: React.Dispatch<React.SetStateAction<string[]>>,
    selectDataRef: React.MutableRefObject<string[]>,
    prevSelectDataRef: React.MutableRefObject<string[]>,
    setShouldUpdate: React.Dispatch<React.SetStateAction<boolean>>
  ) => {
    // Store setSelected for use in onCancel
    entryStatusSetSelectedRef.current = setSelected;

    let currentSelection = entryStatusFilterRef.current;
    prevSelectDataRef.current = [...currentSelection];

    let newSelection: string[] = [];
    if (currentSelection.includes(index)) {
      // Deselect: remove only the clicked index
      newSelection = currentSelection.filter((v) => v !== index);
    } else if (index === "0") {
      // Selecting '0' makes it exclusive
      newSelection = ["0"];
    } else {
      // Add index, but remove '0' if present
      newSelection = currentSelection.filter((v) => v !== "0");
      newSelection.push(index);
    }
    // Ensure only unique values and no empty strings
    newSelection = Array.from(new Set(newSelection)).filter((v) => v !== "");

    entryStatusFilterRef.current = newSelection;
    selectDataRef.current = newSelection;
    setSelected(newSelection);
    setShouldUpdate(true);
    setTimeout(() => setShouldUpdate(false), 20);
  };

  // Handles the action (confirm) for the entry status filter
  const handleEntryStatusOnAction = (
    selectDataRef: React.MutableRefObject<string[]>
  ) => {
    let hasPayable, hasGoods;
    selectDataRef.current = entryStatusFilterRef.current;

    const queryStrings = { ...reduxQuerystring };

    if (selectDataRef.current.length) {
      if (selectDataRef.current.includes("1")) {
        hasPayable = true;
      }
      if (
        selectDataRef.current.includes("0") &&
        selectDataRef.current.length === 1
      ) {
        hasPayable = false;
        hasGoods = false;
      }
      payablesRef.current = hasPayable;
      goodsEntryRef.current = hasGoods;

      queryStrings.has_payable_accounts = payablesRef.current;

      queryStrings.has_goods_receipt = goodsEntryRef.current;

      if (entryStatusRef.current) {
        queryStrings.launch_status = entryStatusRef.current ?? 40;
      }

      if (queryStrings.page) {
        queryStrings.page = 1;
      }

      if (queryStrings.modal) {
        delete queryStrings.modal;
      }

      setQuerystring(queryStrings);
    } else {
      payablesRef.current = undefined;
      delete queryStrings.has_payable_accounts;

      if (entryStatusRef.current) {
        queryStrings.launch_status = entryStatusRef.current ?? 40;
      }

      if (queryStrings.page) {
        queryStrings.page = 1;
      }

      if (queryStrings.modal) {
        delete queryStrings.modal;
      }

      setQuerystring(queryStrings);
    }
    debouncedUpdateAllPaymentSlipsRef();
  };

  const handleEntryStatusOnClear = () => {
    const queryStrings = { ...reduxQuerystring };

    payablesRef.current = undefined;
    goodsEntryRef.current = undefined;

    delete queryStrings.has_payable_accounts;
    delete queryStrings.has_goods_receipt;

    if (entryStatusRef.current) {
      queryStrings.launch_status = entryStatusRef.current ?? 40;
    }

    if (queryStrings.page) {
      queryStrings.page = 1;
    }

    if (queryStrings.modal) {
      delete queryStrings.modal;
    }

    setQuerystring(queryStrings);

    debouncedUpdateAllPaymentSlipsRef();
  };

  // Handles the cancel for the entry status filter
  const handleEntryStatusOnCancel = (
    selectDataRef: React.MutableRefObject<string[]>
  ) => {
    const reset = getDefaultEntryStatusOptions(reduxQuerystring) || [];
    entryStatusFilterRef.current = reset;
    selectDataRef.current = reset;
    // Use setSelected from ref if available
    setTimeout(() => {
      if (entryStatusSetSelectedRef.current) {
        entryStatusSetSelectedRef.current(reset);
      }
    }, 200);
  };

  // Returns the default entry status options based on the querystring
  const getDefaultEntryStatusOptions = (queryStrings: TQuerystringParams) => {
    const hasPayableCondition = queryStrings.has_payable_accounts;
    const hasNotEntryCondition = hasPayableCondition === false;

    if (hasNotEntryCondition) return ["0"];
    if (hasPayableCondition) return ["1"];
    return undefined;
  };

  // Set the initial value for the filter ref
  entryStatusFilterRef.current =
    getDefaultEntryStatusOptions(reduxQuerystring) || [];

  // Pure function for default entry status options
  const handleEntryStatusForceSelectOptions = () => {
    const result = getDefaultEntryStatusOptions(reduxQuerystring);

    return result;
  };

  const handlePeriodForceSelectOptions = () => {
    const queryStrings = { ...reduxQuerystring };

    const calendarOptions = [
      ...CALENDAR_SLIP_CONTENT_OPTIONS.map((string) => string.toLowerCase()),
    ];

    if (
      queryStrings.period &&
      calendarOptions.includes(
        handleRevertTranslateCalendarOptions(
          queryStrings.period as TCalendarMenuOptions
        ) as string
      )
    ) {
      return [
        calendarOptions.indexOf(
          handleRevertTranslateCalendarOptions(
            queryStrings.period as TCalendarMenuOptions
          ) as string
        ),
      ];
    } else if (queryStrings.start_date && queryStrings.end_date) {
      startDateRef.current = queryStrings.start_date;
      endDateRef.current = queryStrings.end_date;

      return [
        queryStrings.start_date.replace(/(\d{4})-(\d{2})-(\d{2})/, "$3/$2/$1"),
        queryStrings.end_date.replace(/(\d{4})-(\d{2})-(\d{2})/, "$3/$2/$1"),
      ];
    }

    return undefined;
  };

  const updateAllPaymentSlipsRef = useCallback(
    async (_entryStatus?: number, endDate?: string) => {
      const queryStringParams = { ...reduxQuerystring };

      if (!queryStringParams.modal) {
        // Cancel previous request if it exists
        if (fetchPaymentSlipsCancelTokenRef.current) {
          fetchPaymentSlipsCancelTokenRef.current.cancel(
            "Operation canceled due to new request."
          );
        }
        // Create a new CancelToken for the new request
        fetchPaymentSlipsCancelTokenRef.current = axios.CancelToken.source();

        endDateRef.current = endDate ?? queryStringParams.end_date;
        startDateRef.current = queryStringParams.start_date;
        payablesRef.current = queryStringParams.has_payable_accounts;
        goodsEntryRef.current = queryStringParams.has_goods_receipt;
        pageRef.current = queryStringParams.page;
        itemsPerPageRef.current = queryStringParams.items_per_page;
        entryStatusRef.current = queryStringParams.launch_status as
          | TInvoiceEntryStatus
          | undefined;

        await dispatch(
          fetchPaymentSlips({
            cancelToken: fetchPaymentSlipsCancelTokenRef.current.token,
          })
        )
          .unwrap()
          .then((response) => {
            allPaymentSlipsRef.current = response?.results;
          })
          .catch((e) => {
            console.log(e);
          });
      }
    },
    [window.location.search, reduxQuerystring]
  );

  const handleFileChange = () => {
    if (selectedOrganization) {
      const globalErrors: string[] = [];

      const handleImport = (file: File) => {
        const formData = new FormData();
        formData.append("boleto", file);
        formData.append("file_name", file.name);

        dispatch(
          importPaymentSlipPDF({
            formData,
            cancelToken: (cancelTokenSource.current as CancelTokenSource).token,
          })
        )
          .unwrap()
          .then(() => {
            if (
              globalErrors.length === 0 &&
              fileInputRef.current &&
              fileInputRef.current.files
            ) {
              dispatch(
                setToastState({
                  variant: "success",
                  shouldShow: true,
                  message: {
                    title: "Sucesso",
                    description:
                      fileInputRef.current.files.length > 1
                        ? "Documentos importados"
                        : "Documento importado",
                  },
                })
              );
            }
          })
          .catch((e) => {
            console.log("error: ", e);
            const errorMessage = backendErrorMessageHandler(e);

            if (typeof errorMessage === "string") {
              globalErrors.push(errorMessage);
            }

            dispatch(
              setToastState({
                variant: "error",
                shouldShow: true,
                message: {
                  title: "Erro",
                  description: globalErrors.join("\n"),
                },
              })
            );
          });
      };

      if (fileInputRef.current && fileInputRef.current.files) {
        const pdfFiles: File[] = [];

        Array.from(fileInputRef.current.files).forEach((file) => {
          if (file.type.includes("pdf")) {
            pdfFiles.push(file);
          }
        });

        Promise.all(
          pdfFiles.map((pdf) => {
            handleImport(pdf);
          })
        ).then(() => {
          setTimeout(() => {
            debouncedUpdateAllPaymentSlipsRef();
          }, 1000);
        });
      }
    }
  };

  const debouncedUpdateAllPaymentSlipsRef = useCallback(
    (_entryStatus?: number | undefined, _endDate?: string | undefined) => {
      const queryStringParams = { ...reduxQuerystring };

      if (!queryStringParams.modal && !isRestoringQuerystring) {
        if (debounceRef.current) clearTimeout(debounceRef.current);
        dispatch(setIsLoadingPaymentSlips(true));
        debounceRef.current = setTimeout(() => {
          updateAllPaymentSlipsRef(_entryStatus, _endDate);
        }, 500);
      }

      if (isRestoringQuerystring) {
        dispatch(setIsRestoringQuerystring(false));
      }
    },
    [updateAllPaymentSlipsRef]
  );

  useEffect(() => {
    debouncedUpdateAllPaymentSlipsRef();
  }, [debouncedUpdateAllPaymentSlipsRef]);

  useEffect(() => {}, [
    paymentSlipState,
    selectedOrganization,
    attachedInvoices,
  ]);

  useEffect(() => {
    entryStatusRef.current = launchStatus;
    const querystring = {
      ...getQuerystringParams(),
      launch_status: launchStatus ?? 40,
      page: 1,
    };
    setQuerystring(querystring);

    startDateRef.current = querystring.start_date;
    endDateRef.current = querystring.end_date;
    itemsPerPageRef.current = querystring.items_per_page;
    pageRef.current = querystring.page;
    searchRef.current = querystring.payment_slips_search;
    payablesRef.current = querystring.has_payable_accounts;
    goodsEntryRef.current = querystring.has_goods_receipt;

    debouncedUpdateAllPaymentSlipsRef();
  }, [launchStatus]);

  useEffect(() => {
    debouncedUpdateAllPaymentSlipsRef();

    return () => {
      if (cancelTokenSource.current) cancelTokenSource.current.cancel();
    };
  }, []);

  return (
    <Container>
      <SummarySection>
        <div>
          <div>
            <h1>Boletos</h1>
            <p>
              <b>CNPJ:&nbsp;</b>
              {selectedOrganization && selectedOrganization?.cnpj
                ? cnpjMask(selectedOrganization.cnpj)
                : ""}
            </p>
          </div>
          {/* {paymentSlipUpdatedAt.responseStatus !== 204 &&
            paymentSlipUpdatedAt.date.length > 0 && (
              <p>
                Atualizado em {format(paymentSlipUpdatedAt.date, "dd/MM/yyyy")}{" "}
                - {format(paymentSlipUpdatedAt.date, "HH:mm")}
              </p>
            )} */}
        </div>
        <div className="buttons-container">
          {/* <Button
            icon="noIcon"
            variant="outline"
            text="Notas Fiscais"
            onClick={() => {
              navigate(ROUTES.HOME + window.location.search);
            }}
          /> */}
          <div></div>
          <Button
            icon="plus"
            iconPosition="left"
            variant="primary"
            text="Importar Boleto"
            onClick={() => {
              if (fileInputRef.current) fileInputRef.current.click();
            }}
          />
          <input
            type="file"
            ref={fileInputRef}
            multiple
            accept=".pdf"
            style={{ display: "none" }}
            onChange={handleFileChange}
          />
        </div>
      </SummarySection>
      <SearchBarSection>
        <SearchBar
          key={reduxQuerystring.payment_slips_search}
          onClear={() => {
            searchRef.current = undefined;

            const queryStrings = { ...reduxQuerystring };

            delete queryStrings.payment_slips_search;

            if (entryStatusRef.current) {
              queryStrings.launch_status = entryStatusRef.current ?? 40;
            }

            setQuerystring(queryStrings);
            dispatch(
              fetchPaymentSlips({
                cancelToken: (
                  fetchPaymentSlipsCancelTokenRef.current as CancelTokenSource
                ).token,
              })
            );
          }}
          $ref={(ref, setSearchString) => {
            const queryStrings = { ...reduxQuerystring };
            if (queryStrings.payment_slips_search && ref.current) {
              const search = decodeURIComponent(
                queryStrings.payment_slips_search
              ).replace(/\+/g, " ");
              ref.current.value = search;
              setSearchString(search);
            }
          }}
          onSearch={(searchPhrase) => {
            searchRef.current = searchPhrase;

            if (selectedOrganization) {
              const queryStrings = { ...reduxQuerystring };

              if (searchRef.current.length > 0) {
                queryStrings.payment_slips_search = searchRef.current;
              } else {
                delete queryStrings.payment_slips_search;
              }

              if (entryStatusRef.current) {
                queryStrings.launch_status = entryStatusRef.current ?? 40;
              }

              setQuerystring(queryStrings);

              // Cancel previous request before dispatching a new one
              if (fetchPaymentSlipsCancelTokenRef.current) {
                fetchPaymentSlipsCancelTokenRef.current.cancel(
                  "Operation canceled due to new request."
                );
              }
              fetchPaymentSlipsCancelTokenRef.current =
                axios.CancelToken.source();

              dispatch(
                fetchPaymentSlips({
                  cancelToken: fetchPaymentSlipsCancelTokenRef.current.token,
                })
              );
            }
          }}
          variant="default"
          placeholder="Pesquisar"
        />
        <SearchBarSectionSubcontainer id={searchBarContainerId}>
          <DropdownFilter
            buttonVariant="calendar"
            menuVariant="calendar-slip"
            onSelect={handleCalendarOnSelect}
            key={
              reduxQuerystring.period +
              "" +
              reduxQuerystring.start_date +
              reduxQuerystring.end_date
            }
            onClear={handleCalendarOnClear}
            forceSelectOptionsByIndex={(() => {
              const result = handlePeriodForceSelectOptions();
              return shouldRejectFilledEntryStatus ||
                (result && typeof result[0] === "string")
                ? []
                : (result as number[]);
            })()}
            filled={(() => {
              const result = handlePeriodForceSelectOptions();

              console.log("filled period: ", result);

              return result === undefined
                ? result
                : typeof result[0] === "string"
                ? (result as string[])
                : [CALENDAR_SLIP_CONTENT_OPTIONS[result[0]]];
            })()}
          />
          <DropdownFilter
            buttonVariant="checkCircle"
            placeholder="Lançamentos"
            content={entryStatusOptions}
            menuVariant="unlabeled"
            search={false}
            customFilter={handleEntryStatusCustomFilter}
            onAction={handleEntryStatusOnAction}
            onCancel={handleEntryStatusOnCancel}
            onClear={handleEntryStatusOnClear}
            hasBottomBar
            key={
              reduxQuerystring.has_payable_accounts +
              "" +
              reduxQuerystring.has_goods_receipt
            }
            forceSelectOptionsByIndex={(() => {
              const result = handleEntryStatusForceSelectOptions();
              return shouldRejectFilledEntryStatus
                ? undefined
                : result
                ? result.map(Number)
                : undefined;
            })()}
            filled={(() => {
              const result = handleEntryStatusForceSelectOptions();
              return result === undefined
                ? result
                : [...result.toString().replaceAll(",", "")];
            })()}
          />
        </SearchBarSectionSubcontainer>
      </SearchBarSection>
      <MobileSupportContainer>
        <TabsGroup
          initialActiveTabIndex={
            launchStatus === undefined
              ? 0
              : launchStatus === 10
              ? 1
              : launchStatus === 20
              ? 2
              : launchStatus === 30
              ? 3
              : 0
          }
          onClickItems={[
            () => setLaunchStatus(undefined), // "Todas"
            () => setLaunchStatus(10), // "Pendentes"
            () => setLaunchStatus(20), // "Finalizadas"
            () => setLaunchStatus(30), // "Recusadas"
          ]}
        >
          <>
            <h2>Todas</h2>
            <div></div>
          </>
          <>
            <h2>Pendentes</h2>
          </>
          <>
            <h2>Finalizadas</h2>
            <div></div>
          </>
          <>
            <h2>Recusadas</h2>
            <div></div>
          </>
        </TabsGroup>
      </MobileSupportContainer>

      {paymentSlipState && (
        <TableGrid
          key={shouldUpdateComponent + "-paymentSlip-tablegrid"}
          row="doubleRow"
          columns={{
            tableHead: {
              width: [gridTemplateColumns],
            },
            tableBody: {
              width: [gridTemplateColumns],
            },
          }}
          onAction={() => {
            window.location.reload();
          }}
          emptyState={{
            isEmptyState: !isLoading && paymentSlipState?.results.length === 0,
            title: "Nenhum boleto encontrado",
            description: "Altere os filtros e realize a busca novamente",
          }}
          secondRow={{
            params: (paymentSlipState?.results ?? []).map(
              (paymentSlip, index) => ({
                data: {
                  ...(secondRowDataFormatter(
                    paymentSlip
                  ) as TCellNotTagMiscellaneous),
                  skeleton: isLoading
                    ? {
                        containerCss: {
                          display: "flex",
                          justifyContent: "space-between",
                          width: "calc(100vw - 155px)",
                          margin: "0 20px",
                        },
                        values: [
                          { width: "216px", height: "16px" },
                          {
                            width: "96px",
                            height: "16px",
                            style: { maxWidth: "96px", overflow: "hidden" },
                          },
                        ],
                      }
                    : undefined,
                },
                leftSideCustomNode: !isLoading && (
                  <>
                    {paymentSlip.bar_code.length > 0 &&
                      handleSecondRowLeftSideCustomNodeRender(
                        paymentSlip,
                        index
                      )}
                  </>
                ),
                rightSideCustomNode: !isLoading && (
                  <>
                    {handleSecondRowRightSideCustomNodeRender(
                      paymentSlip,
                      index
                    )}
                  </>
                ),
              })
            ),
          }}
          customMarginTop="12px"
          selectType={{
            type: "multiSelect",
            fullData: allPaymentSlipsRef.current,
          }}
          tableHead={{
            customPaddingTop: "0px",
            value: [
              { style: "noIcon", value: "Enviado em", showSkeleton: isLoading },
              { style: "noIcon", value: "Origem", showSkeleton: isLoading },
              { style: "noIcon", value: "Emitente", showSkeleton: isLoading },
              { style: "noIcon", value: "Valor", showSkeleton: isLoading },
              {
                style: "noIcon",
                value: "Vencimento",
                showSkeleton: isLoading,
              },
              { style: "noIcon", value: "Lançamento", showSkeleton: isLoading },
              { style: "noIcon", value: "Opções", showSkeleton: isLoading },
            ],
          }}
          isLoading={isLoading}
          tableBody={
            isLoading
              ? new Array(5).fill("").map(() => ({
                  elementId: "",
                  file_nfe: null,
                  file_xml: null,
                  body: [
                    {
                      style: "default",
                      value: "",
                      skeleton: { values: [{ width: "72px" }] },
                    },
                    {
                      style: "default",
                      value: "",
                      skeleton: { values: [{ width: "150px" }] },
                    },
                    {
                      style: "default",
                      value: "",
                      skeleton: { values: [{ width: "177px" }] },
                    },
                    {
                      style: "default",
                      value: "",
                      skeleton: { values: [{ width: "100px" }] },
                    },
                    {
                      style: "default",
                      value: "",
                      skeleton: { values: [{ width: "88px" }] },
                    },
                    {
                      style: "default",
                      value: "",
                      skeleton: {
                        containerCss: { display: "flex", gap: "4px" },
                        values: [
                          {
                            width: "40px",
                            height: "40px",
                            variant: "circle",
                          },
                        ],
                      },
                    },
                    {
                      style: "default",
                      value: "",
                      skeleton: { values: [{ width: "32px" }] },
                    },
                  ] as TTableBody<TCellStyleVariants>[],
                }))
              : (paymentSlipState?.results ?? []).map(
                  (paymentSlip: TPaymentSlip, index: number) => ({
                    elementId: paymentSlip.uuid,
                    file_nfe: null,
                    file_xml: null,
                    file_boleto: paymentSlip.file_boleto,
                    body: rowFormatter(paymentSlip, index),
                  })
                )
          }
          footer={{
            customStyle: {
              width: `calc(100vw - 48px - ${sidebarOffset}px)`,
            },
            leftSideDescription:
              " | Total de " +
              paymentSlipState.count +
              (paymentSlipState.count > 1
                ? " registros encontrados"
                : " registro encontrado"),
            onSelectItemsPerPage(amount) {
              const queryStrings = { ...reduxQuerystring };

              if (queryStrings.page) {
                pageRef.current = queryStrings.page;
              }

              if (pageRef.current) queryStrings.page = pageRef.current;

              queryStrings.items_per_page = amount;

              setQuerystring(queryStrings);

              dispatch(
                fetchPaymentSlips({
                  cancelToken: (
                    fetchPaymentSlipsCancelTokenRef.current as CancelTokenSource
                  ).token,
                })
              );
            },
            customPagination: paymentSlipState
              ? {
                  fixedBottom: {
                    isFixedAtTheBottom: true,
                    customBottomPosition: "0px",
                  },
                  currentPage: `${paymentSlipState?.current_page}`,
                  buttonBackward: {
                    disabled: paymentSlipState.current_page === 1,
                    onClick() {
                      pageRef.current = paymentSlipState.current_page - 1;

                      const queryStrings = { ...reduxQuerystring };

                      if (queryStrings.items_per_page) {
                        itemsPerPageRef.current = queryStrings.items_per_page;
                      }

                      if (
                        selectedOrganization &&
                        paymentSlipState.current_page !== 1 &&
                        cancelTokenSource.current
                      ) {
                        if (pageRef.current)
                          queryStrings.page = pageRef.current;
                        setQuerystring(queryStrings);

                        dispatch(
                          fetchPaymentSlips({
                            cancelToken:
                              fetchPaymentSlipsCancelTokenRef.current.token,
                          })
                        );
                      }
                    },
                  },
                  buttonForward: {
                    disabled:
                      paymentSlipState.current_page ===
                      paymentSlipState.pages.length,
                    onClick() {
                      if (
                        paymentSlipState.current_page ===
                        paymentSlipState.pages.length
                      ) {
                        pageRef.current = paymentSlipState.current_page;
                      } else {
                        pageRef.current = paymentSlipState.current_page + 1;
                      }

                      const queryStrings = { ...reduxQuerystring };

                      if (queryStrings.items_per_page) {
                        itemsPerPageRef.current = queryStrings.items_per_page;
                      }

                      if (
                        paymentSlipState.current_page !==
                          paymentSlipState.pages.length &&
                        cancelTokenSource.current
                      ) {
                        if (pageRef.current)
                          queryStrings.page = pageRef.current;

                        setQuerystring(queryStrings);

                        dispatch(
                          fetchPaymentSlips({
                            cancelToken:
                              fetchPaymentSlipsCancelTokenRef.current.token,
                          })
                        );
                      }
                    },
                  },
                  pages: paymentSlipState.pages.map((page) => {
                    return {
                      value: Object.keys(page)[0],
                      onClick() {
                        let temp =
                          Object.values(page)[0].match(/.*?page=(\d+)&per_/);

                        if (temp !== null && temp[1]) {
                          pageRef.current = parseInt(temp[1]);
                        } else {
                          pageRef.current = 1;
                        }

                        const queryStrings = { ...reduxQuerystring };

                        if (queryStrings.items_per_page) {
                          itemsPerPageRef.current = queryStrings.items_per_page;
                        }

                        if (selectedOrganization && cancelTokenSource.current) {
                          const queryStrings = { ...reduxQuerystring };
                          if (pageRef.current)
                            queryStrings.page = pageRef.current;
                          setQuerystring(queryStrings);

                          dispatch(
                            fetchPaymentSlips({
                              cancelToken:
                                fetchPaymentSlipsCancelTokenRef.current.token,
                            })
                          );
                        }
                      },
                    };
                  }),
                }
              : undefined,
          }}
        />
      )}

      {shouldOpenPayable && (
        <Modal
          key={shouldOpenPayable + "-payable"}
          shouldOpen={shouldOpenPayable}
          onClose={() => {
            setShouldOpenPayable(false);
          }}
          icon={{ type: "dolarSign", color: "rose" }}
          title="Lançar contas a pagar"
          main={{
            style: "textOnly",
            content: [
              {
                style: "default",
                text: "Deseja criar uma nova conta a pagar ou vincular o boleto a uma conta já criada na Fintera?",
                shouldBreakLine: true,
              },
            ],
          }}
          footer={{
            style: "default",
            buttons: [
              {
                iconPosition: "left",
                icon: "link",
                variant: "outline",
                text: "Vincular",
                onClick() {
                  setShouldOpenPayable(false);
                  setShouldOpenLinkPayableModal(true);
                },
              },
              {
                iconPosition: "left",
                icon: "plus",
                variant: "primary",
                text: "Criar nova",
                onClick() {
                  setShouldOpenPayable(false);
                  setShouldOpenPayableModal(true);
                },
              },
            ],
          }}
        />
      )}

      {shouldOpenPayableModal && (
        <Modal
          key={shouldOpenPayableModal + "-payableModal"}
          shouldOpen={shouldOpenPayableModal}
          icon={{ type: "dolarSign", color: "rose" }}
          title="Lançar como contas a pagar"
          onClose={() => {
            setShouldOpenPayableModal(false);
          }}
          main={{
            style: "form",
            content: {
              preset: "addPaymentSlip",
              paymentSlip: payableModalPaymentSlipRef.current as TPaymentSlip,
              footer: {
                buttons: [
                  {
                    icon: "noIcon",
                    text: "Cancelar",
                    variant: "secondary",
                    onClick() {
                      setShouldOpenPayableModal(false);
                    },
                  },
                  {
                    iconPosition: "left",
                    icon: "checkmark",
                    text: "Lançar conta a pagar",
                    variant: "primary",
                    onClick() {
                      dispatch(
                        fetchPaymentSlips({
                          cancelToken: (
                            fetchPaymentSlipsCancelTokenRef.current as CancelTokenSource
                          ).token,
                        })
                      );
                      setShouldOpenPayableModal(false);
                    },
                  },
                ],
              },
            },
          }}
        />
      )}
      {shouldOpenLinkPayableModal && (
        <Modal
          key={shouldOpenLinkPayableModal + "-linkPayableModal"}
          shouldOpen={shouldOpenLinkPayableModal}
          icon={{ type: "link", color: "rose" }}
          title="Vincular boleto a conta já lançada"
          onClose={() => {
            setShouldOpenLinkPayableModal(false);
          }}
          main={{
            style: "form",
            content: {
              preset: "linkPayable",
              paymentSlip: payableModalPaymentSlipRef.current as TPaymentSlip,
              footer: {
                buttons: [
                  {
                    icon: "noIcon",
                    text: "Cancelar",
                    variant: "secondary",
                    onClick() {
                      setShouldOpenLinkPayableModal(false);
                    },
                  },
                  {
                    iconPosition: "left",
                    icon: "checkmark",
                    text: "Vincular boleto como anexo",
                    variant: "primary",
                    isLoading: isLinkPayableLoading,

                    onClick(selectRow) {
                      if (selectRow.hasInstallments) {
                        selectPayableRef.current = selectRow.selectPayable;
                        setShouldOpenLinkPayableModal(false);
                        setShouldOpenInstallmentAccountModal(true);
                      } else {
                        if (payableModalPaymentSlipRef.current) {
                          setIsLinkPayableLoading(true);

                          dispatch(
                            linkPaymentSlipToPayable({
                              paymentSlipUuid:
                                payableModalPaymentSlipRef.current.uuid,
                              payableId: selectRow.selectPayable.id,
                              cancelToken: (
                                cancelTokenSource.current as CancelTokenSource
                              ).token,
                            })
                          )
                            .unwrap()
                            .then((_response) => {
                              setIsLinkPayableLoading(false);
                              dispatch(
                                fetchPaymentSlips({
                                  cancelToken: (
                                    fetchPaymentSlipsCancelTokenRef.current as CancelTokenSource
                                  ).token,
                                })
                              );
                              dispatch(
                                setToastState({
                                  variant: "success",
                                  shouldShow: true,
                                  message: {
                                    title: "Sucesso",
                                    description:
                                      "Boleto vinculado à contas a pagar",
                                  },
                                })
                              );
                              setShouldOpenLinkPayableModal(false);
                            })
                            .catch((e) => {
                              const errorMessage =
                                backendErrorMessageHandler(e);
                              console.log("error: ", e);
                              setIsLinkPayableLoading(false);
                              dispatch(
                                setToastState({
                                  variant: "error",
                                  shouldShow: true,
                                  message: {
                                    title: "Erro ao vincular boleto",
                                    description:
                                      typeof errorMessage === "string"
                                        ? errorMessage
                                        : "Ocorreu um erro ao vincular o boleto à Contas a Pagar, tente novamente",
                                  },
                                })
                              );
                              setShouldOpenLinkPayableModal(false);
                            });
                        }
                      }
                    },
                  },
                ],
              },
            },
          }}
        />
      )}
      {shouldOpenInstallmentAccountModal && (
        <Modal
          shouldOpen={shouldOpenInstallmentAccountModal}
          onClose={() => {
            setShouldOpenInstallmentAccountModal(false);
          }}
          icon={{ type: "link", color: "rose" }}
          title="Vincular à conta parcelada"
          main={{
            style: "form",
            content: {
              preset: "installmentAccount",
              paymentSlip: payableModalPaymentSlipRef.current as TPaymentSlip,
              footer: {
                buttons: [
                  {
                    variant: "secondary",
                    icon: "noIcon",
                    text: "Cancelar",
                    onClick() {
                      setShouldOpenInstallmentAccountModal(false);
                    },
                  },
                  {
                    variant: "primary",
                    iconPosition: "left",
                    icon: "checkmark",
                    text: "Vincular boleto como anexo",
                    isLoading: isLinkPayableLoading,
                    onClick() {
                      if (
                        payableModalPaymentSlipRef.current &&
                        selectPayableRef.current
                      ) {
                        setIsLinkPayableLoading(true);

                        dispatch(
                          linkPaymentSlipToPayable({
                            paymentSlipUuid:
                              payableModalPaymentSlipRef.current.uuid,
                            payableId: `${selectPayableRef.current.id}`,
                            cancelToken: (
                              cancelTokenSource.current as CancelTokenSource
                            ).token,
                          })
                        )
                          .unwrap()
                          .then((_response) => {
                            setIsLinkPayableLoading(false);
                            dispatch(
                              fetchPaymentSlips({
                                cancelToken: (
                                  fetchPaymentSlipsCancelTokenRef.current as CancelTokenSource
                                ).token,
                              })
                            );
                            dispatch(
                              setToastState({
                                variant: "success",
                                shouldShow: true,
                                message: {
                                  title: "Sucesso",
                                  description:
                                    "Boleto vinculado à contas a pagar",
                                },
                              })
                            );
                            setShouldOpenInstallmentAccountModal(false);
                          })
                          .catch((e) => {
                            const errorMessage = backendErrorMessageHandler(e);
                            console.log("error: ", e);
                            setIsLinkPayableLoading(false);
                            dispatch(
                              setToastState({
                                variant: "error",
                                shouldShow: true,
                                message: {
                                  title: "Erro ao vincular boleto",
                                  description:
                                    typeof errorMessage === "string"
                                      ? errorMessage
                                      : "Ocorreu um erro ao vincular o boleto à Contas a Pagar, tente novamente",
                                },
                              })
                            );
                            setShouldOpenInstallmentAccountModal(false);
                          });
                      }
                    },
                  },
                ],
              },
            },
          }}
        />
      )}
      {shouldOpenLinkInvoiceModal && (
        <Modal
          shouldOpen={shouldOpenLinkInvoiceModal}
          onClose={() => {
            if (clearSelectedInvoicesRef.current) {
              clearSelectedInvoicesRef.current();
            }
            setPaymentSlipToAttachLinks(null);
            setShouldOpenLinkInvoiceModal(false);
          }}
          icon={{ type: "link", color: "rose" }}
          title="Selecionar notas fiscais"
          main={{
            style: "form",
            content: {
              preset: "linkInvoice",
              footer: {
                buttons: [
                  {
                    variant: "secondary",
                    icon: "noIcon",
                    text: "Cancelar",
                    onClick() {
                      if (clearSelectedInvoicesRef.current) {
                        clearSelectedInvoicesRef.current();
                      }
                      setPaymentSlipToAttachLinks(null);
                      setShouldOpenLinkInvoiceModal(false);
                    },
                  },
                  {
                    variant: "primary",
                    iconPosition: "left",
                    icon: "checkmark",
                    text: "Confirmar selecionado(s)",
                    isLoading: isLinkPayableLoading,
                    onClick(data: {
                      selectedInvoices: TInvoice[];
                      clearSelectedInvoices: () => void;
                    }) {
                      clearSelectedInvoicesRef.current =
                        data.clearSelectedInvoices;
                      data.selectedInvoices.forEach((invoice, index) => {
                        if (paymentSlipToAttachLinks) {
                          setIsLinkPayableLoading(true);

                          dispatch(
                            attachInvoiceToPaymentSlip({
                              paymentSlipUuid: paymentSlipToAttachLinks.uuid,
                              invoiceUuid: invoice.uuid,
                              cancelToken: (
                                cancelTokenSource.current as CancelTokenSource
                              ).token,
                            })
                          )
                            .unwrap()
                            .then((_response) => {
                              if (index === data.selectedInvoices.length - 1) {
                                setIsLinkPayableLoading(false);
                                dispatch(
                                  fetchPaymentSlips({
                                    cancelToken: (
                                      fetchPaymentSlipsCancelTokenRef.current as CancelTokenSource
                                    ).token,
                                  })
                                );
                                dispatch(
                                  setToastState({
                                    variant: "success",
                                    shouldShow: true,
                                    message: {
                                      title: "Sucesso",
                                      description:
                                        data.selectedInvoices.length > 1
                                          ? "Notas vinculadas à conta a pagar"
                                          : "Nota vinculada à contas a pagar",
                                    },
                                  })
                                );
                                data.clearSelectedInvoices();
                                setPaymentSlipToAttachLinks(null);
                                setShouldOpenLinkInvoiceModal(false);
                              }
                            })
                            .catch((e) => {
                              const errorMessage =
                                backendErrorMessageHandler(e);
                              setIsLinkPayableLoading(false);
                              dispatch(
                                setToastState({
                                  variant: "error",
                                  shouldShow: true,
                                  message: {
                                    title: "Erro ao vincular nota",
                                    description:
                                      typeof errorMessage === "string"
                                        ? errorMessage
                                        : "Ocorreu um erro ao vincular a nota à Contas a Pagar, tente novamente",
                                  },
                                })
                              );
                              if (clearSelectedInvoicesRef.current) {
                                clearSelectedInvoicesRef.current();
                              }
                              setPaymentSlipToAttachLinks(null);
                              setShouldOpenLinkInvoiceModal(false);
                            });
                        }
                      });
                    },
                  },
                ],
              },
            },
          }}
        />
      )}
      <Modal
        key={paymentSlipToDelete?.uuid}
        title="Recusar boleto"
        icon={{ type: "exclamationTriangle", color: "red" }}
        main={{
          style: "textOnly",
          content: [
            {
              text: "Tem certeza que deseja recusar o boleto ",

              style: "default",
              shouldBreakLine: false,
            },
            {
              text: paymentSlipToDelete ? paymentSlipToDelete?.bar_code : "",
              style: "bold",
              shouldBreakLine: false,
            },
            { text: "?", style: "default", shouldBreakLine: true },
          ],
        }}
        footer={{
          style: "default",
          buttons: [
            {
              variant: "secondary",
              icon: "noIcon",
              text: "Cancelar",
              onClick() {
                setPaymentSlipToDelete(undefined);
              },
            },
            {
              variant: "red",
              iconPosition: "left",
              icon: "checkmark",
              text: "Sim, recusar",
              onClick() {
                if (paymentSlipToDelete) {
                  dispatch(
                    updatePaymentSlipLaunchStatus({
                      paymentSlipUuid: paymentSlipToDelete.uuid,
                      status: "decline",
                      cancelToken: (
                        cancelTokenSource.current as CancelTokenSource
                      ).token,
                    })
                  )
                    .unwrap()
                    .then(() => {
                      setPaymentSlipToDelete(undefined);
                      dispatch(
                        setToastState({
                          variant: "success",
                          shouldShow: true,
                          message: {
                            title: "Sucesso",
                            description: "Boleto recusado",
                          },
                        })
                      );
                      dispatch(
                        fetchPaymentSlips({
                          cancelToken: (
                            fetchPaymentSlipsCancelTokenRef.current as CancelTokenSource
                          ).token,
                        })
                      );
                    })
                    .catch((e) => {
                      const errorMessage = backendErrorMessageHandler(e);
                      setPaymentSlipToDelete(undefined);
                      dispatch(
                        setToastState({
                          variant: "error",
                          shouldShow: true,
                          message: {
                            title: "Erro",
                            description:
                              typeof errorMessage === "string"
                                ? errorMessage
                                : "Não foi possível recusar o boleto, tente novamente",
                          },
                        })
                      );
                    });
                }
              },
            },
          ],
        }}
        shouldOpen={paymentSlipToDelete !== undefined}
        onClose={() => {
          setPaymentSlipToDelete(undefined);
        }}
      />
      <Modal
        key={invoiceToBreakLink?.target.uuid}
        title="Remover vínculo"
        icon={{ type: "breakLink", color: "red" }}
        main={{
          style: "textOnly",
          content: [
            {
              text: "Tem certeza que deseja remover o vínculo com esta nota fiscal?",

              style: "default",
              shouldBreakLine: false,
            },
          ],
        }}
        footer={{
          style: "default",
          buttons: [
            {
              variant: "secondary",
              icon: "noIcon",
              text: "Cancelar",
              onClick() {
                setInvoiceToBreakLink(undefined);
              },
            },
            {
              variant: "red",
              iconPosition: "left",
              icon: "checkmark",
              text: "Sim, remover",
              onClick() {
                if (invoiceToBreakLink) {
                  dispatch(
                    detachInvoiceFromPaymentSlip({
                      paymentSlipUuid: invoiceToBreakLink.target.uuid,
                      invoiceUuid: invoiceToBreakLink.origin.uuid,
                      cancelToken: (
                        cancelTokenSource.current as CancelTokenSource
                      ).token,
                    })
                  )
                    .then(() => {
                      setInvoiceToBreakLink(undefined);
                      dispatch(
                        setToastState({
                          variant: "success",
                          shouldShow: true,
                          message: {
                            title: "Sucesso",
                            description: "Vínculo removido",
                          },
                        })
                      );
                      dispatch(
                        fetchPaymentSlips({
                          cancelToken: (
                            fetchPaymentSlipsCancelTokenRef.current as CancelTokenSource
                          ).token,
                        })
                      );
                    })
                    .catch((e) => {
                      const errorMessage = backendErrorMessageHandler(e);
                      setInvoiceToBreakLink(undefined);
                      dispatch(
                        setToastState({
                          variant: "error",
                          shouldShow: true,
                          message: {
                            title: "Erro",
                            description:
                              typeof errorMessage === "string"
                                ? errorMessage
                                : "Não foi possível remover o vínculo, tente novamente",
                          },
                        })
                      );
                    });
                }
              },
            },
          ],
        }}
        shouldOpen={invoiceToBreakLink !== undefined}
        onClose={() => {
          setInvoiceToBreakLink(undefined);
        }}
      />
      {invoiceToRename !== undefined && (
        <Modal
          key={invoiceToRename?.uuid}
          title="Renomear arquivo"
          icon={{ type: "edit", color: "rose" }}
          main={{
            style: "form",
            content: {
              preset: "renameDocument",
              data: invoiceToRename,
              footer: {
                buttons: [
                  {
                    variant: "secondary",
                    icon: "noIcon",
                    text: "Cancelar",
                    onClick() {
                      setInvoiceToRename(undefined);
                    },
                  },
                  {
                    variant: "primary",
                    iconPosition: "left",
                    icon: "checkmark",
                    text: "Salvar",
                    onClick(label: string) {
                      if (invoiceToRename && cancelTokenSource.current) {
                        dispatch(
                          renameInvoiceLabel({
                            invoiceUuid: invoiceToRename.uuid,
                            label,
                            cancelToken: cancelTokenSource.current.token,
                          })
                        )
                          .unwrap()
                          .then(() => {
                            setInvoiceToRename(undefined);
                            dispatch(
                              setToastState({
                                variant: "success",
                                shouldShow: true,
                                message: {
                                  title: "Sucesso",
                                  description: "Nota fiscal renomeada",
                                },
                              })
                            );
                            dispatch(
                              fetchPaymentSlips({
                                cancelToken: (
                                  fetchPaymentSlipsCancelTokenRef.current as CancelTokenSource
                                ).token,
                              })
                            );
                          })
                          .catch((e) => {
                            const errorMessage = backendErrorMessageHandler(e);
                            setInvoiceToRename(undefined);
                            dispatch(
                              setToastState({
                                variant: "error",
                                shouldShow: true,
                                message: {
                                  title: "Erro",
                                  description:
                                    typeof errorMessage === "string"
                                      ? errorMessage
                                      : "Não foi possível renomear a nota fiscal, tente novamente",
                                },
                              })
                            );
                          });
                      }
                    },
                  },
                ],
              },
            },
          }}
          shouldOpen={invoiceToRename !== undefined}
          onClose={() => {
            setInvoiceToRename(undefined);
          }}
        />
      )}
    </Container>
  );
}

export default PaymentSlip;
